<button [type]="type" [disabled]="disabled" [ngClass]="classes" (click)="onClick($event)"
  [attr.aria-label]="(text | translate)"
  [attr.title]="(text | translate)"
  class="flex justify-center items-center gap-3 {{extraClass}}"
  [style.background]="variant === 'primary' ? 'var(--btn-bg-gradient)' : 'transparent hover:bg-blue-50'">
  <img *ngIf="iconPath" [src]="iconPath" alt="icon" />
  <ng-container *ngIf="!loading; else loader">
    {{ text | translate }}
  </ng-container>

  <ng-template #loader>
    <span class="flex justify-center items-center gap-2">
      <span class="loader w-4 h-4 border-2 border-t-transparent rounded-full animate-spin"></span>
      Loading...
    </span>
  </ng-template>
</button>